
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.724 2.026a5.497 5.497 0 00-7.783 0l-.653.657-.653-.653a5.5 5.5 0 00-7.782 7.774l8.435 8.427 8.436-8.423a5.496 5.496 0 000-7.782z","fill":"#CC3434"}})])
          )
        }
      }
    